<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>payment</md-icon>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <tabs :tab-name="['Enterprise Agreements', 'Stripe Accounts']">
                            <template slot="tab-pane-1">
                                <div class="row">
                                    <template v-if="!licenseDetails || !licenseDetails.length">
                                        <p>No result found.</p>
                                    </template>
                                    <template v-else>
                                        <div class="column">
                                            <md-table>
                                                <md-table-row>
                                                    <md-table-head>Transaction Id</md-table-head>
                                                    <md-table-head>Product</md-table-head>
                                                    <md-table-head>Agreement Date</md-table-head>
                                                    <md-table-head>Payment Date</md-table-head>
                                                    <md-table-head>Amount</md-table-head>
                                                    <md-table-head>Payment Source</md-table-head>
                                                </md-table-row>
                                                <md-table-row
                                                    class="ea"
                                                    v-for="(item, itemIndex) in licenseDetails"
                                                    :key="`licenseDetails-${itemIndex}`"
                                                    @click.stop="showEAItems(item)"
                                                >
                                                    <md-table-cell>
                                                        {{ item.transactionId }}
                                                    </md-table-cell>
                                                    <md-table-cell>
                                                        {{ item.productName }}
                                                    </md-table-cell>
                                                    <md-table-cell>
                                                        {{
                                                            item.agreementDate
                                                                | dateFormat(DATE_TYPES.internationalDate)
                                                        }}
                                                    </md-table-cell>
                                                    <md-table-cell>
                                                        {{
                                                            item.paymentDate | dateFormat(DATE_TYPES.internationalDate)
                                                        }}
                                                    </md-table-cell>
                                                    <md-table-cell>
                                                        {{ `${item.currency} ${formatNumber(item.amount, 2)}` }}
                                                    </md-table-cell>
                                                    <md-table-cell>
                                                        {{ item.paymentSource }}
                                                    </md-table-cell>
                                                </md-table-row>
                                            </md-table>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <template slot="tab-pane-2">
                                <div class="row">
                                    <template v-if="!billingAccounts || !billingAccounts.length">
                                        <p>No billing account found.</p>
                                    </template>
                                    <template v-else>
                                        <div class="column">
                                            <md-table>
                                                <md-table-row>
                                                    <md-table-head>Subscription Id</md-table-head>
                                                    <md-table-head>Subscription Status</md-table-head>
                                                    <md-table-head>Quantity</md-table-head>
                                                    <md-table-head>Total Price</md-table-head>
                                                </md-table-row>
                                                <template v-for="acct in billingAccounts">
                                                    <md-table-row
                                                        v-for="(item, itemIndex) in acct.subscriptions"
                                                        :key="`${acct.billingAcountId}sub-${itemIndex}`"
                                                    >
                                                        <md-table-cell>
                                                            {{ item.paymentSubscriptionId }}
                                                        </md-table-cell>
                                                        <md-table-cell>
                                                            {{ item.subscriptionStatus }}
                                                        </md-table-cell>
                                                        <md-table-cell>
                                                            {{ item.quantity }}
                                                        </md-table-cell>
                                                        <md-table-cell>
                                                            {{ `${item.currency} ${formatNumber(item.totalPrice, 2)}` }}
                                                        </md-table-cell>
                                                    </md-table-row>
                                                </template>
                                            </md-table>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </tabs>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { Tabs } from '@/components';
import EntAgreementItemsModal from './components/EntAgreementItemsModal';

export default {
    name: 'BillingAccountDetails',
    components: { Tabs },
    mixins: [GeneralMixin],
    data() {
        return {
            qryTeamId: null,
            licenseDetails: [],
            billingAccounts: []
        };
    },
    methods: {
        async getLicenseDetails() {
            this.$_handleLoaderState(true, 'Fetching license details');
            try {
                const api = `/api/billings/support/license-details?teamId=${this.qryTeamId}`;
                const { data } = await handleRequests(api);
                if (data && data.length) {
                    this.licenseDetails = [...data];
                } else {
                    this.licenseDetails = [];
                }
            } catch (e) {
                const message = 'Unable to retrieve license details.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        async getBillingAccounts() {
            this.$_handleLoaderState(true, 'Fetching billing accounts');
            try {
                const api = `/api/billings/support/billing-accounts?teamId=${this.qryTeamId}`;
                const { data } = await handleRequests(api);
                if (data && data.length) {
                    this.billingAccounts = [...data];
                } else {
                    this.billingAccounts = [];
                }
            } catch (e) {
                const message = 'Unable to retrieve billing accounts.';
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        showEAItems(item) {
            this.$modal.show(EntAgreementItemsModal, {
                transactionId: item.transactionId,
                currency: item.currency,
                items: item.enterpriseAgreementItems || []
            });
        },
        formatNumber(num, digit) {
            return (Math.round(num * 100) / 100).toFixed(digit).toLocaleString();
        }
    },
    async mounted() {
        if (this.$route.query?.teamId) {
            this.qryTeamId = +this.$route.query.teamId;
            this.getLicenseDetails();
            this.getBillingAccounts();
        } else {
            this.$router.push({ name: 'Billing Accounts' });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .md-table-row.ea:hover {
    background-color: #fafafa;
    cursor: pointer;
}
</style>
